import { render, staticRenderFns } from "./teacherRY.vue?vue&type=template&id=186120c5&"
import script from "./teacherRY.vue?vue&type=script&lang=js&"
export * from "./teacherRY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports